<template>
  <div class="AddMaterials">
    <el-form :model="form" inline>
      <el-table
        :data="form.contractCollectionPlanList"
        align="left"
        class="tablePage employeelist xzl-el-table-class"
        style="width: 100%"
      >
        <el-table-column width="120px" label="材料名称">
          <div slot-scope="scope">
            <el-select
              v-if="scope.row.isEditing"
              v-model.number="
                form.contractCollectionPlanList[scope.$index].materialId
              "
              filterable
              placeholder="请选择"
              @change="(v) => handleChange(v, scope.$index)"
            >
              <el-option
                v-for="item in accessoriesList"
                :key="item.id"
                :label="item.materialName"
                :value="item.id"
              >
              </el-option>
            </el-select>

            <span v-else>{{ scope.row.materialName }}</span>
          </div>
        </el-table-column>
        <el-table-column width="100px" label="成本价">
          <div slot-scope="scope">
            <span>{{ scope.row.costAmount | separator }}</span>
          </div>
        </el-table-column>

        <el-table-column width="100px" label="售价">
          <div slot-scope="scope">
            <el-input
              size="mini"
              v-if="scope.row.isEditing"
              type="number"
              placeholder="0"
              v-model.number="
                form.contractCollectionPlanList[scope.$index].salesAmount
              "
            ></el-input>
            <span v-else>{{ scope.row.salesAmount }}</span>
          </div>
        </el-table-column>
        <el-table-column label="数量">
          <div slot-scope="scope">
            <el-input
              size="mini"
              v-if="scope.row.isEditing"
              type="number"
              placeholder="0"
              v-model.number="
                form.contractCollectionPlanList[scope.$index].useAmount
              "
            ></el-input>
            <span v-else>{{ scope.row.useAmount }}</span>
          </div>
        </el-table-column>
        <el-table-column label=" "></el-table-column>
        <el-table-column v-if="status === 4" label="操作" width="100px">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.isEditing"
              @click="handleRowSaveOrEdit(scope.$index, 1)"
              type="text"
              size="small"
              >保存</el-button
            >
            <el-button
              v-else
              type="text"
              @click="handleRowSaveOrEdit(scope.$index, 2)"
              size="small"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleDeleteRow(scope.$index)"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="tableNoData">
            <div class="bgBox iconfont iconzanwu"></div>
            <div class="text">暂时没有数据呀～</div>
          </div>
        </template>
      </el-table>
      <div v-if="status === 4" class="add-plat-btn" @click="handleAddPlan">添加材料配件</div>
    </el-form>
  </div>
</template>

<script>
import {
  saveContractCollectionPlan,
  removeContractCollectionPlan,
} from "@/api/ContractManagement";
import { getSimpleList, getUserSimpleList } from "@/api/ElevatorManagement";
export default {
  data() {
    return {
      accessoriesList: [],
      canSearch: true,
      form: {
        contractCollectionPlanList: [
          {
            materialId: null,
            materialName: null,
            salesAmount: null,
            costAmount: null,
            useAmount: null,
            isEditing: true,
          },
        ],
      },
    };
  },
  props: ["accessories", "status"],
  mounted() {
    this.getSimpleListFun();
  },
  methods: {
    handleChange(v, index) {
      const item = this.accessoriesList.find((item) => item.id === v);
      let row = this.form.contractCollectionPlanList[index];
      if (item) {
        this.$set(row, "salesAmount", item.salesAmount);
        this.$set(row, "materialName", item.materialName);
        this.$set(row, "costAmount", item.costAmount);
      }
    },
    async getSimpleListFun(v = "") {
      this.canSearch = false;
      const res = await getSimpleList({ keyword: v, size: 1000 });
      if (res.code === 200) {
        this.accessoriesList = res.data.map((item) => ({
          ...item,
          materialId: item.id,
        }));
      }
      this.canSearch = true;
    },
    handleRowSaveOrEdit(index, type) {
      if (type === 1) {
        this.form.contractCollectionPlanList[index].isEditing = false;
        this.$emit("confirmMaterials", this.form.contractCollectionPlanList);
      } else if (type === 2) {
        // 编辑
        this.form.contractCollectionPlanList[index].isEditing = true;
      }
    },
    async saveContractCollectionPlan(val) {
      let params = { ...val };
      params.contractId = this.contractId;
      params.updatePlan = 1;
      params.receivableAmount = params.receivableAmount * 1;
      const res = await saveContractCollectionPlan(params);
      if (res.code === 200) {
        let message = "添加成功";
        if (params.id) {
          message = "编辑成功";
        }
        this.$message.success(message);
        val.id = res.data;
        val.isEditing = false;
      }
    },
    handleDeleteRow(index) {
      this.form.contractCollectionPlanList.splice(index, 1);
      this.$emit("confirmMaterials", this.form.contractCollectionPlanList);
    },
    async removeContractCollectionPlan(index) {
      const res = await removeContractCollectionPlan({
        idList: [this.form.contractCollectionPlanList[index].id],
      });
      if (res.code === 200) {
        this.$message.success("删除成功");
        this.form.contractCollectionPlanList.splice(index, 1);
      }
    },
    handleAddPlan() {
      this.form.contractCollectionPlanList.push({
        materialId: null,
        materialName: null,
        salesAmount: null,
        costAmount: null,
        useAmount: null,
        isEditing: true,
      });
    },
  },
  watch: {
    accessories: {
      handler(newVal) {
        if (newVal && newVal.length) {
          const arr = JSON.parse(JSON.stringify(newVal));
          this.form.contractCollectionPlanList = arr.map((item) => ({
            ...item,
            isEditing: false,
          }));
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.AddMaterials {
  .add-plat-btn {
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: #ccc;
    border: 1px dashed #ccc;
    margin-top: 16px;
    border-radius: 2px;
    cursor: pointer;
    &:hover {
      color: #5b8cff;
      border-color: #5b8cff;
    }
  }
  .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
  .el-input__icon {
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AnnualInspection/components/AddMaterials.vue